import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import Home from "../External/Home";
import About from "../External/About";
import Contact from "../External/Contact";
import PrivacyPolicy from "../External/PrivacyPolicy";
import TermsofService from "../External/TermsofService";
import PaymentSecurity from "../External/PaymentSecurity";

import Dashboard from "../Dashboard/Dashboard";
import MyBooking from "../Dashboard/MyBooking";
// import BookingDetails from '../Dashboard/BookingDetails';

import Hotel from "../Products/Hotel/Hotel";
import Results from "../Products/Hotel/Results";
import Availability from "../Products/Hotel/Availability";
import HotelDetail from "../Products/Hotel/HotelDetail";
import HotelBooking from "../Products/Hotel/HotelBooking";
import CheckOut from "../Products/Hotel/CheckOut";
import ThankYou from "../Products/Hotel/ThankYou";

import AgentDetails from "../Identity/AgentDetails";

import Settings from "../Settings/Settings";
import ManageMarkup from "../Settings/ManageMarkup";
import UserAdmin from "../Settings/UserAdmin";
import Myprofile from "../Settings/Myprofile";
import ChangePassword from "../Settings/ChangePassword";

import Approval from "../Dashboard/Approval";
import ApprovalDetail from "../Dashboard/ApprovalDetail";
import TripQueue from "../Dashboard/TripQueue";
import TripQueueDetail from "../Dashboard/TripQueueDetail";

// Hotel Reservations
import ReservationHotelTransactions from "../Reservations/Hotel/AllTransactions";
import ReservationHotelEnquiryTransactions from "../Reservations/Hotel/AllEnquiryTransactions";
import HotelTransactionsDetails from "../Reservations/Hotel/TransactionsDetails";
import HotelCustomerInvoice from "../Reservations/Hotel/HotelCustomerInvoice";
import HotelAgencyInvoice from "../Reservations/Hotel/HotelAgencyInvoice";
import HotelCancellationBooking from "../Reservations/Hotel/CancellationBooking";
import HotelPrintInvoice from "../Reservations/Hotel/PrintInvoice";
import HotelPrintTicket from "../Reservations/Hotel/HotelPrintTicket";
import CancelledBookings from "../Reports/Hotel/CancelledBookings";

import HdfcPaymentResponse from "../Payment/HdfcPaymentResponse";
const Layout = () => {
  return (
    <>
      {/* HEADER can be here */}

      <Routes>
        {/* INTERNAL LOGGED-IN ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/payment-security" element={<PaymentSecurity />} />

        {/* <Route path="/flight" element={<Flight />} />
        <Route path="/flight/result" element={<Result />} />
        <Route path="/flight/multicity" element={<MultiCity />} />
        <Route path="/flight/booking" element={<Booking />} /> */}

        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/mybooking" element={<MyBooking />} />
        {/* <Route path="/dashboard/bookingDetails" element={<BookingDetails />} /> */}
        <Route path="/approval" element={<Approval />} />
        <Route
          path="/dashboard/approval/Approval-detail"
          element={<ApprovalDetail />}
        />
        <Route path="/TripQueue" element={<TripQueue />} />
        <Route
          path="/dashboard/approval/TripQueuedetail"
          element={<TripQueueDetail />}
        />

        {/* My Profile */}
        {/* <Route path="/my-profile/personal-information" element={<PersonalInformation />} />
        <Route path="/my-profile/organization-profile" element={<OrganizationProfile />} />
        <Route path="/my-profile/contact-details" element={<ContactDetails />} />
        <Route path="/my-profile/documents" element={<Documents />} />
        <Route path="/my-profile/preferences" element={<Preferences />} />
        <Route path="/my-profile/reporting-parameters" element={<ReportingParameters />} /> */}

        {/* Hotel */}
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/hotel/result" element={<Results />} />
        <Route path="/availability" element={<Availability />} />
        <Route path="/hotel/hoteldetail" element={<HotelDetail />} />
        <Route path="/hotel/hotelbooking" element={<HotelBooking />} />
        <Route path="/hotel/checkout" element={<CheckOut />} />
        <Route path="/hotel/thankyou" element={<ThankYou />} />

        {/* Others */}
        {/* <Route path="/bus" element={<Bus />} />
        <Route path="/bus/list" element={<List />} />
        <Route path="/bus/BusBooking" element={<BusBooking />} />
        <Route path="/bus/BusPayment" element={<BusPayment />} />
        <Route path="/bus/seat-layout" element={<SeatLayout />} /> */}

        {/* Hotel Reservations */}
        <Route
          path="/reservations/hotel/alltransactions"
          element={<ReservationHotelTransactions />}
        />
        <Route
          path="/reservations/hotel/allenquirytransactions"
          element={<ReservationHotelEnquiryTransactions />}
        />
        <Route
          path="/reservations/hotel/TransactionsDetails"
          element={<HotelTransactionsDetails />}
        />
        <Route
          path="/reservations/hotel/HotelCustomerInvoice"
          element={<HotelCustomerInvoice />}
        />
        <Route
          path="/reservations/hotel/HotelAgencyInvoice"
          element={<HotelAgencyInvoice />}
        />

        <Route
          path="/reservations/hotel/CancellationBooking"
          element={<HotelCancellationBooking />}
        />
        <Route
          path="/reservations/hotel/PrintInvoice"
          element={<HotelPrintInvoice />}
        />
        <Route
          path="/reservations/hotel/PrintTicket"
          element={<HotelPrintTicket />}
        />

        {/* Hotel Reports */}
        <Route
          path="/Reports/Hotel/CancelledBookings"
          element={<CancelledBookings />}
        />
        <Route
          path="/Reports/Hotel/AllTransactions"
          element={<ReservationHotelTransactions />}
        />

        {/* Settings */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/manage" element={<ManageMarkup />} />
        <Route path="/settings/useradmin" element={<UserAdmin />} />
        <Route path="/settings/myprofile" element={<Myprofile />} />
        <Route path="/settings/changepassword" element={<ChangePassword />} />

        <Route path="/agent-details" element={<AgentDetails />} />
        <Route path="/HdfcPaymentResponse" element={<HdfcPaymentResponse />} />
      </Routes>

      {/* FOOTER can be here */}
    </>
  );
};

export default Layout;
